import MicroModal from "micromodal";
import Shepherd from 'shepherd.js';
import {offset} from '@floating-ui/dom/dist/floating-ui.dom.umd';
import router from "./router";
import {config} from "./config";
import {layers, map, profile} from "./common";
import * as L from "leaflet/dist/leaflet";
import {postFetch} from "./utils";

const DEMO_SPOT = 'DEMO';
const DEMO_PROFILE = 'test-wind';
const SPOTS_TEMPLATES = [
  {"img": "la-torche-surf.jpg", "label": "La Torche - Surf", "ref":"TS","mapCenter":[47.81100172556795,-3.5006999361894358],"mapZoom":8.89958997647146,"dataLayers":["wind","waves","tide_fc","waves_fc","weather_fc"],"bgLayers":["wm"],"point":[48.3006,-4.9823],"pois":["LaTorche"],"webcams":[],"tideGauges":["/port/Saint-Guenole"],"windSensors":["29158001","29214001","29168001"],"wavesSensors":[],"tempSensors":["29158001","29214001","29168001"],"edit":false},
  {"img": "cap-coz-kite.jpg", "label": "Cap Coz - Kite", "ref":"CK","mapCenter":[47.81330734584138,-3.972513257537114],"mapZoom":11.163284457697534,"dataLayers":["wind","waves","wind_fc","tide_fc","webcam","weather_fc"],"bgLayers":["wm"],"point":[47.81,-4],"pois":["CapCoz"],"webcams":["/webcam/capcoz","/webcam/begmeil","/webcam/concarneau"],"tideGauges":["/port/Port-la-Foret"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "benodet-plaisance.jpg", "label": "Bénodet - Plaisance", "ref":"BP", "mapCenter":[47.77170546467042,-3.8829836074927075],"mapZoom":9.764252745635858,"dataLayers":["wind","waves","wind_fc","tide_fc","webcam","weather_fc"],"bgLayers":["wm"],"point":[47.78,-4.06],"pois":["Benodet"],"webcams":["/webcam/SainteMarine","/webcam/penmarch"],"tideGauges":["/port/Benodet"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "kergelen-voile-legere.jpg", "label": "Kergelen - Voile légère", "ref":"KVL","mapCenter":[47.65435797658462,-3.564770566510287],"mapZoom":10.129325538328795,"dataLayers":["wind","waves","weather_fc","wind_fc","tide_fc"],"bgLayers":["wm"],"point":[47.7,-3.4],"pois":["kerguelen"],"webcams":[],"tideGauges":["/port/port-louis-locmalo"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "sainte-barbe-surf.jpg", "label": "Sainte-Barbe - Surf", "ref":"SBS","mapCenter":[47.35411123065658,-3.0836277749981797],"mapZoom":9.46302267505024,"dataLayers":["wind","waves","weather_fc","waves_fc","webcam","tide_fc"],"bgLayers":["wm"],"point":[47.3322,-3.2873],"pois":["sainte-barbe"],"webcams":["/webcam/semaphore-d-etel-plouhinec"],"tideGauges":["/port/portivy"],"windSensors":["56069001","56009001","5","6","1","10438252","73091265","73091277","73091286"],"wavesSensors":[],"tempSensors":["56069001","56009001"],"edit":false},
  {"img": "baie-de-quiberon-voile.jpg", "label": "Baie de Quiberon - Voile", "ref":"BQV","mapCenter":[47.369813133091384,-2.7993731353657574],"mapZoom":9.928505491271716,"dataLayers":["wind","waves","webcam","tide_fc","wind_fc","weather_fc"],"bgLayers":["wm"],"point":[47.51,-3],"pois":["baie-de-quiberon"],"webcams":["/webcam/saint-philibert","/webcam/quiberon","/webcam/houat"],"tideGauges":["/port/la-trinite-sur-mer"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "piriac-voile.jpg", "label": "Piriac - Voile", "ref":"PV","mapCenter":[47.31318444465053,-2.6113630173287565],"mapZoom":9.978710503035986,"dataLayers":["wind","wind_fc","webcam","weather_fc"],"bgLayers":["wm"],"point":[47.41,-2.61],"pois":["piriac"],"webcams":["/webcam/mesquer-lanseria","/webcam/port-de-penerf"],"tideGauges":[],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "la-baule-voile.jpg", "label": "La Baule - Voile", "ref":"BV","mapCenter":[47.21620157676546,-2.294812196937526],"mapZoom":11.27802911640019,"dataLayers":["wind","wind_fc","waves","tide_fc","weather_fc"],"bgLayers":["wm"],"point":[47.26,-2.4],"pois":["LaBaule"],"webcams":[],"tideGauges":["/port/LePouliguen"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "saint-gildas-voile.jpg", "label": "Saint-Gildas - Voile", "ref":"SGV","mapCenter":[47.07583366066162,-2.570473728358112],"mapZoom":9.680760620678683,"dataLayers":["wind_fc","waves","tide_fc","weather_fc","wind"],"bgLayers":["wm"],"point":[47.15,-2.25],"pois":["saintgildas"],"webcams":[],"tideGauges":["/port/pointedesaintgildas"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false},
  {"img": "la-govelle-surf.jpg", "label": "La Govelle - Surf", "ref":"GS","mapCenter":[47.24096426887133,-2.5605645497447176],"mapZoom":10.762341288414444,"dataLayers":["wind","weather_fc","waves_fc","tide_fc","waves"],"bgLayers":["wm"],"point":[47.2615,-2.4595],"pois":["lagovelle"],"webcams":[],"tideGauges":["/port/le-croisic"],"windSensors":[],"wavesSensors":[],"tempSensors":[],"edit":false}
];

export function toggleAccountSpots(btn) {
  if (btn.classList.contains('expanded')) {
    btn.nextElementSibling.classList.add('hidden');
    btn.classList.remove('expanded');
  } else {
    btn.nextElementSibling.classList.remove('hidden');
    btn.classList.add('expanded');
  }
}

export function showSpot(btn, spotIndex) {
  toggleAccountSpots(document.querySelector("#account_spots > button:first-child"));
  loadUserSpot(spotIndex, false);
}

export function configureSpots() {
  toggleAccountSpots(document.querySelector("#account_spots > button:first-child"));
  MicroModal.show('spots_modal', {disableScroll: true});
}

export function configureSpot(spotIndex) {
  MicroModal.close('spots_modal');
  loadUserSpot(spotIndex, true);
}

export function configureDemoSpot() {
  MicroModal.close('spots_modal');
  loadDemoSpot();
  const activeTour = document.querySelector("dialog.shepherd-element.shepherd-enabled");
  if (!activeTour) {
    startSpotsTour('zoom-step');
  }
}

export function showSpotsTemplates() {
  MicroModal.close('spots_modal');
  MicroModal.show('spots_templates_modal', {disableScroll: true});
}

export function toggleSpotTemplate(btnElt) {
  const prev = document.querySelector("#spots_templates_list .selected"),
    userSpots = getUserProfile().spots.map(s => s.ref);
  if (prev) {
    prev.classList.remove('selected');
    if (prev.nextElementSibling.querySelector("p")) prev.nextElementSibling.querySelector("p").remove();
    if (prev.nextElementSibling.querySelector("select")) prev.nextElementSibling.querySelector("select").remove();
    if (prev.nextElementSibling.querySelector("button")) prev.nextElementSibling.querySelector("button").remove();
  }
  btnElt.classList.add("selected");
  if (btnElt.classList.contains("selected")) {
    btnElt.nextElementSibling.insertAdjacentHTML('beforeend',
      `<p>Utiliser ce modèle pour le spot :</p><select name="spot_template_target" id="spot_template_target">${userSpots.map(s => `<option value="${s}">${s}</option>`)}</select><button type="button" onclick="wm.applySpotTemplate()">Valider</button>`);
  }
}

export function applySpotTemplate() {
  const userProfile = getUserProfile(), targetSpotRef = document.querySelector("#spot_template_target").value,
    selectedTemplate = document.querySelector("#spots_templates_list .selected").getAttribute("data-template");

  const templateData = {...SPOTS_TEMPLATES[SPOTS_TEMPLATES.findIndex(st => st.ref === selectedTemplate)]};
  delete templateData.img;
  delete templateData.label;

  userProfile.spots[userProfile.spots.findIndex(s => s.ref === targetSpotRef)] = templateData;

  saveUserProfile(userProfile);
  MicroModal.close('spots_templates_modal');

  router.navigate(`/profil/${userProfile.id}/spots/${selectedTemplate}`);
}

export function getUserSpot(spotRef) {
  const userProfile = getUserProfile();
  return spotRef === DEMO_SPOT ? userProfile.demoSpot : userProfile.spots.find(s => s.ref === spotRef);
}

export function displayEditControls(spotRef) {
  const editControls = document.querySelector("#edit_spot_controls");
  editControls.classList.remove('hidden');
  editControls.querySelector("#edit_spot_ref").value = spotRef;
  editControls.setAttribute("data-spot", spotRef);
}

export function selectPinnedElements(userSpot) {
  console.debug('selectPinnedElements: ' + JSON.stringify(userSpot));
  if (userSpot.pois.length) {
    for (const poi of document.querySelectorAll(`${userSpot.pois.map(p => "#poi_" + p + ".weather_poi").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.webcams.length) {
    for (const poi of document.querySelectorAll(`${userSpot.webcams.map(w => ".webcam_spot a[data-href='" + w + "']").join(',')}`)) {
      poi.closest("g[data-edit]").classList.add("edit_pinned");
    }
  }
  if (userSpot.tideGauges.length) {
    for (const poi of document.querySelectorAll(`${userSpot.tideGauges.map(t => ".tide_spot a[data-href='" + t + "']").join(',')}`)) {
      poi.closest("g[data-edit]").classList.add("edit_pinned");
    }
  }
  if (userSpot.windSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.windSensors.map(s => "#sensor_" + s + ".wind_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.wavesSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.wavesSensors.map(s => "#sensor_" + s + ".wave_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.tempSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.tempSensors.map(s => "#sensor_" + s + ".temp_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
}

export function saveCurrentSpot() {
  const userProfile = getUserProfile(), prevSpotRef = document.querySelector("#edit_spot_controls").getAttribute('data-spot'),
    isDemo = prevSpotRef === DEMO_SPOT, newSpotRef = isDemo ? DEMO_SPOT : document.querySelector("#edit_spot_ref").value;
  if (!newSpotRef || (newSpotRef !== prevSpotRef && userProfile.spots.find(s => s.ref === newSpotRef))) {
    document.querySelector("#info_spot_modal_title").innerHTML = `Spot ${newSpotRef} - Enregistrement impossible`;
    document.querySelector("#info_spot_modal_content").innerHTML = `L'enregistrement du spot ${newSpotRef} n'a pas pu aboutir. Veuillez vérifier que vous avez bien choisi un nom unique pour votre spot (3 caractères max.).`
  } else {
    const mainPoi = document.querySelector(".weather_poi[data-main-poi='true']"), pinnedPois = pinnedElements('.weather_poi');
    const newSpotData = {
      ref: newSpotRef,
      mapCenter: [map.instance.getCenter().lat, map.instance.getCenter().lng],
      mapZoom: map.instance.getZoom(),
      dataLayers: [...layers.dataLayers],
      bgLayers: Array.from(document.querySelectorAll(".map_layer.active")).map(l => l.getAttribute('data-bg')),
      point: map.currentFocus ? [map.currentFocus.lat, map.currentFocus.lng] : null,
      pois: (mainPoi ? [mainPoi.id.split('_')[1], ...pinnedPois.filter(p => p !== mainPoi.id.split('_')[1])] : pinnedPois),
      webcams: pinnedElements('.webcam_spot'),
      tideGauges: pinnedElements('.tide_spot'),
      windSensors: pinnedElements('.wind_sensor'),
      wavesSensors: pinnedElements('.wave_sensor'),
      tempSensors: pinnedElements('.temp_sensor')
    };
    if (isDemo) {
      router.navigate("/");
      document.querySelector("#edit_spot_controls").classList.add('hidden');
      document.querySelector("#info_spot_modal_title").innerHTML = `Spot de démo - Configuration terminée`;
      document.querySelector("#info_spot_modal_content").innerHTML = `Configurez vos 3 spots de la même manière, via le menu "mes spots" en entête du site. Rejouez la démo à partir de l'entrée <strong>config</strong> du menu, en cliquant à nouveau sur <strong>Configurer le spot de démo</strong>.`;
    } else {
      userProfile.spots[userProfile.spots.findIndex(s => s.ref === prevSpotRef)] = newSpotData;
      saveUserProfile(userProfile);
      router.navigate(`/profil/${userProfile.id}/spots/${newSpotRef}`);
      updateSpotsMenu(userProfile.spots);
      document.querySelector("#info_spot_modal_title").innerHTML = `Spot ${newSpotRef} - Enregistrement réussi`;
      document.querySelector("#info_spot_modal_content").innerHTML = `Vous pouvez accéder à ce spot :<br/>- via le menu "mes spots" en entête du site<br/>` +
        `- directement via l'adresse <a href="${window.location.protocol}//${window.location.host}/profil/${userProfile.id}/spots/${newSpotRef}">${window.location.host}/profil/${userProfile.id}/spots/${newSpotRef}</a>`;
    }
  }
  MicroModal.show('info_spot_modal', {disableScroll: true});
}

export function cancelEditSpot() {
  if (window.confirm("Annuler la configuration du spot en cours ?")) {
    const spotRef = document.querySelector("#edit_spot_controls").getAttribute('data-spot');
    router.navigate(`/profil/${userProfile.id}/spots/${spotRef}`);
  }
}

export function createAccount() {
  const signUpForm = document.querySelector("#wm_sign_up_form");
  if (signUpForm.reportValidity()) {
    const formData = new FormData(signUpForm);
    postFetch(`${config.backEndUrl}/wind_users.json`, formData)
      .then((resp) => {
        console.debug("resp: " + JSON.stringify(resp));
        if (resp.success) {
          document.querySelector("#info_spot_modal_title").innerHTML = `Compte en attente de validation`;
          document.querySelector("#info_spot_modal_content").innerHTML = `<p>Veuillez consulter votre boîte de réception pour finaliser la création de votre compte.<br/>` +
            `Une fois votre compte validé, vous pourrez <button type="button" onclick="wm.dismissAccountCreation()"><strong>vous connecter</strong></button> à l'aide vos identifiants.</p>`;
        } else {
          document.querySelector("#info_spot_modal_title").innerHTML = `Erreur lors de la création de compte`;
          document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
        }
        MicroModal.close('form_modal');
        MicroModal.show('info_spot_modal', {disableScroll: true});
      }).catch((error) => {
      console.error("error: " + JSON.stringify(error));
    });
  }
}

export function createMockAccount() {
  const signUpForm = document.querySelector("#wm_sign_up_form");
  if (signUpForm.reportValidity()) {
    MicroModal.close('form_modal');
    document.querySelector("#info_spot_modal_title").innerHTML = `Création de compte réussie`;
    document.querySelector("#info_spot_modal_content").innerHTML = `<p>Merci pour votre saisie, votre compte windfrance a bien été créé.<br/>` +
      `<strong>MODE TEST<br/>Pour vous connecter au compte windfrance de test, utilisez les identifiants suivants :<br/>` +
      `E-mail : test@windmorbihan.com - Mot de passe : TestWindFrance25</strong></p>` +
      `<button type="button" class="configure_spot" onclick="wm.dismissAccountCreation()">Je me connecte</button>`
    MicroModal.show('info_spot_modal', {disableScroll: true});
  } else {

  }
}

export function resetPassword() {
  document.querySelector("#info_spot_modal_title").innerHTML = `Réinitialiser votre mot de passe`;
  document.querySelector("#info_spot_modal_content").innerHTML = `<form id="wm_reset_pwd_form" action="" method="post" class="modal_form grid-2">` +
    `<div class="form_field"><label for="account_email">Adresse email</label><input type="email" placeholder="Email" id="account_email" data-form-type="username" name="user[email]" required/></div>` +
    `<div><button class="reset_pwd_button" type="button" value="Connexion" onclick="wm.submitPasswordReset()">Réinitialiser</button></div>` +
  `</form>`;
  MicroModal.close('form_modal');
  MicroModal.show('info_spot_modal', {disableScroll: true});
}

export function submitPasswordReset() {
  const resetForm = document.querySelector("#wm_reset_pwd_form");
  if (resetForm.reportValidity()) {
    const formData = new FormData(resetForm);
    postFetch(`${config.backEndUrl}/wind_users/reset_password.json`, formData)
      .then((resp) => {
        document.querySelector("#info_spot_modal_title").innerHTML = `Demande de réinitialisation transmise`;
        document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
      }).catch((error) => {
        console.error("error: " + JSON.stringify(error));
      });
  }
}

export function validateUserProfile() {
  const usrProfile = document.querySelector("#user_profile"), choices = usrProfile.querySelectorAll(".choice_field");
  let totalAnswers = 0;
  for (const choice of choices) {
    const maxAnswers = parseInt(choice.getAttribute("data-max")),
      selectedAnswers = choice.querySelectorAll("input[type='checkbox']:checked");
    totalAnswers += selectedAnswers.length;
    if (maxAnswers < selectedAnswers.length) {
      selectedAnswers[selectedAnswers.length - 1].setCustomValidity(`Veuillez sélectionner au maximum ${maxAnswers} choix`);
    } else {
      for (const a of choice.querySelectorAll("input[type='checkbox']")) {
        a.setCustomValidity('');
      }
    }
  }
  console.debug('totalAnswers: ' + totalAnswers.toString());
  if (totalAnswers === 0) {
    choices[0].querySelector("input[type='checkbox']").setCustomValidity('Veuillez sélectionner au moins une pratique (loisir ou professionnelle)')
  } else {
    choices[0].querySelector("input[type='checkbox']").setCustomValidity('');
  }
}

export function dismissAccountCreation() {
  MicroModal.close('info_spot_modal');
  MicroModal.show('form_modal', {disableScroll: true});
  document.querySelector("#form_modal #form_cta > button:first-child").click();
}

export function mockSignIn() {
  if (document.querySelector("#wm_sign_in_form input[type='email']").value === 'test@windmorbihan.com' &&
    document.querySelector("#wm_sign_in_form input[type='password']").value === 'TestWindFrance25') {
    if (!localStorage.getItem('windUser')) {
      saveUserProfile(defaultUserProfile());
    }
    signInUser();
    MicroModal.close('form_modal');
    document.querySelector("#info_spot_modal_title").innerHTML = `Connexion réussie`;
    document.querySelector("#info_spot_modal_content").innerHTML = `<p>Bienvenue sur votre compte windfrance.</p>` +
      `<div class="guided_tour"><button type="button" onclick="wm.startSpotsTour()">Démarrer la visite guidée</button></div>`;
    MicroModal.show('info_spot_modal', {disableScroll: true});
  } else {
    console.error("login attempt failed");
  }
}

export function createWindSession() {
  const signInForm = document.querySelector("#wm_sign_in_form");
  if (signInForm.reportValidity()) {
    const formData = new FormData(signInForm);
    postFetch(`${config.backEndUrl}/wind_users/login.json`, formData)
      .then((resp) => {
        console.debug("resp: " + JSON.stringify(resp));
        if (resp.success) {
          saveUserProfile(resp.user, false);
          signInUser();
          document.querySelector("#info_spot_modal_title").innerHTML = `Connexion réussie`;
          document.querySelector("#info_spot_modal_content").innerHTML = `<p>Bienvenue sur votre compte windfrance.</p>` +
            `<div class="guided_tour"><button type="button" onclick="wm.startSpotsTour()">Démarrer la visite guidée</button></div>`;
        } else {
          document.querySelector("#info_spot_modal_title").innerHTML = `Erreur lors de la connexion`;
          document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
        }
        MicroModal.close('form_modal');
        MicroModal.show('info_spot_modal', {disableScroll: true});
      }).catch((error) => {
      console.error("error: " + JSON.stringify(error));
    });
  }
}

export function signInUser() {
  const userProfile = getUserProfile();
  updateSpotsMenu(userProfile.spots);
  profile.id = userProfile.id;
  if (typeof window._paq !== 'undefined') {
    console.debug('setUserId: ' + profile.id.toString());
    window._paq.push(['setUserId', profile.id]);
  }
  document.querySelector("#account_spots").classList.remove('hidden');
  document.querySelector("#wind_france_top").classList.add('hidden');
  document.querySelector("#map_layers #rain_fc").classList.remove("disabled");
  document.querySelector("#map_layers #rain_fc").setAttribute("onclick", "wm.toggleLayer(this, 'rain_fc')");
  document.querySelector("#map_layers #rain_fc").setAttribute("title", "Radar pluie");
}

function updateSpotsMenu(userSpots) {
  document.querySelector("#account_spots button[data-spot-index='1'] strong").innerHTML = userSpots[0].ref;
  document.querySelector("#account_spots button[data-spot-index='2'] strong").innerHTML = userSpots[1].ref;
  document.querySelector("#account_spots button[data-spot-index='3'] strong").innerHTML = userSpots[2].ref;
}

export function startSpotsTour(step = null) {
  MicroModal.close('info_spot_modal');
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    confirmCancel: true,
    confirmCancelMessage: "Quitter la démo ?",
    keyboardNavigation: false,
    defaultStepOptions: {
      scrollTo: false,
      cancelIcon: {enabled: true},
      floatingUIOptions: {
        middleware: [offset(10)]
      }
    }
  });
  tour.addStep({
    id: 'menu-spots-step',
    text: 'Cliquez sur le menu <strong>mes spots</strong><br/>afin de les configurer.',
    attachTo: {element: '#account_spots > button:first-child', on: 'bottom'},
    advanceOn: { selector: '#account_spots', event: 'click' }
  });
  tour.addStep({
    id: 'edit-spots-step',
    text: "Cliquez sur <strong><i class='fa-solid fa-cog'></i>&nbsp;config</strong>.",
    attachTo: {element: '#account_spots > div > button:last-child', on: 'bottom'},
    advanceOn: {selector: '#account_spots > div > button:last-child', event: 'click'}
  });
  tour.addStep({
    id: 'select-edit-spot',
    text: "Dans la fenêtre qui s'ouvre, sélectionnez le spot que vous souhaitez personnaliser : nous allons ici <strong>configurer le spot de démo</strong>.",
    attachTo: {element: '#spots_modal_content .guided_tour > button', on: 'top'},
    advanceOn: {selector: '#spots_modal_content .guided_tour > button', event: 'click'}
  });
  tour.addStep({
    id: 'zoom-step',
    text: "Sélectionnez le <strong>niveau de zoom</strong> que vous souhaitez. Par exemple, nous allons nous positionner autour de Belle Île.",
    buttons: [
      {
        text: 'Suiv. >',
        classes: 'tour_next_btn',
        action: function() {
          map.instance.setView(new L.LatLng(47.2695, -3.184), 10.8);
          tour.next();
        }
      }
    ]
  });
  tour.addStep({
    id: 'sensor-step',
    text: "Vous pouvez sélectionner <strong>un ou plusieurs capteurs</strong>. Dans notre exemple, <strong>cliquez sur le capteur Belle Île</strong>.",
    attachTo: {element: '#sensor_56009001', on: 'bottom'},
    advanceOn: { selector: '#sensor_56009001', event: 'click' }
  });
  tour.addStep({
    id: 'layer-step',
    text: "Vous pouvez <strong>activer différents calques</strong>. Dans notre exemple, <strong>cliquez sur le calque des marégraphes en surbrillance</strong>.",
    attachTo: {element: '#map_layers #tide', on: 'top'},
    advanceOn: {selector: '#map_layers #tide', event: 'click'}
  });
  tour.addStep({
    id: 'tide-step',
    text: "<strong>Choisissez un marégraphe</strong>. Dans notre exemple, <strong>cliquez sur celui du Palais</strong>.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: ".tide_spot a[title='Le Palais']", on: 'bottom'},
    advanceOn: { selector: ".tide_spot a[title='Le Palais']", event: 'click' }
  });
  tour.addStep({
    id: 'fc-step',
    text: "Vous pouvez <strong>sélectionner d'autres calques</strong>. Dans notre exemple, <strong>activez le calque de prévisions du vent</strong> en surbrillance.",
    attachTo: {element: '#map_layers #wind_fc', on: 'top'},
    advanceOn: {selector: '#map_layers #wind_fc', event: 'click'}
  });
  tour.addStep({
    id: 'fc-point-step',
    text: "Cliquez sur un point de votre choix dans la zone en surbrillance afin d'afficher la valeur prévue en ce point.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        document.querySelector("#particles_wrapper").insertAdjacentHTML('beforeend', '<div id="fc-point-step-overlay"></div>');
        resolve();
      });
    },
    attachTo: {element: '#fc-point-step-overlay', on: 'top'},
    advanceOn: {selector: '#markers_layer', event: 'click'}
  });
  tour.addStep({
    id: 'weather-step',
    text: "Vous pouvez <strong>ajouter plusieurs météogrammes</strong>. Pour cela, <strong>activez le calque météo</strong> en surbrillance.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: '#map_layers #weather_fc', on: 'top'},
    advanceOn: {selector: '#map_layers #weather_fc', event: 'click'}
  });
  tour.addStep({
    id: 'poi-step-1',
    text: "Sélectionnez un météogramme - dans cet exemple <strong>Donnant</strong>. Le 1er météogramme sélectionné sera activé automatiquement.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: '#poi_donnant', on: 'top'},
    advanceOn: {selector: '#poi_donnant', event: 'click'}
  });
  tour.addStep({
    id: 'poi-step-2',
    text: "Vous pouvez sélectionner un 2ème météogramme - dans cet exemple <strong>Le Palais</strong>. Son icône sera affichée sur votre spot.",
    attachTo: {element: '#poi_le-palais', on: 'top'},
    advanceOn: {selector: '#poi_le-palais', event: 'click'}
  });
  tour.addStep({
    id: 'rename-step',
    text: "Enfin, <strong>donnez un nom</strong> à votre spot (3 caractères maximum) puis cliquez sur <strong>Enregistrer</strong> dans l'encart à gauche.",
    scrollTo: false,
    attachTo: {element: '#edit_spot_controls', on: 'bottom'},
    advanceOn: {selector: '#save_current_spot', event: 'click'}
  });
  tour.addStep({
    id: 'other-data-step',
    text: "Toutes les données présentes sur le site peuvent être intégrées de la même façon :<br/>- observations vent, houle, température<br/>- prévisions vent, vagues<br/>- prévisions pluie via carte radar<br/>- météogrammes, webcams, marégraphes",
    buttons: [
      {
        text: 'Terminer la visite',
        action: tour.complete
      }
    ]
  });

  if (step) {
    tour.show(step);
  } else {
    tour.start();
  }
}

function pinnedElements(selector) {
  const pinnedElts= document.querySelectorAll(`g.zoom_wrapper ${selector}.edit_pinned`),
    refs = [];
  for (const el of pinnedElts) {
    if (el.id) {
      refs.push(el.id.split('_')[1]);
    } else {
      refs.push(el.querySelector("a").getAttribute('data-href'));
    }
  }
  return refs;
}

function loadUserSpot(spotIndex, editMode) {
  const userProfile = getUserProfile(), userSpot = userProfile.spots[spotIndex - 1], spotRef = userSpot?.ref;
  router.navigate(`/profil/${userProfile.id}/spots/${spotRef}${editMode ? '?edit=true' : ''}`);
}

function loadDemoSpot() {
  router.navigate(`/profil/${DEMO_PROFILE}/spots/DEMO?edit=true`);
}

function defaultUserSpot(ref) {
  return {
    ref: ref,
    mapCenter: [...config.mapCenter],
    mapZoom: config.mapZoom,
    bgLayers: ['wm'],
    dataLayers: ['wind', 'waves'],
    point: null,
    pois: [],
    webcams: [],
    tideGauges: [],
    windSensors: [],
    wavesSensors: [],
    tempSensors: []
  }
}

function getUserProfile() {
  const storedProfile = localStorage.getItem('windUser');
  return storedProfile ? JSON.parse(localStorage.getItem('windUser')) : defaultUserProfile();
}

function saveUserProfile(profileData, remote = true) {
  console.debug('saving user profile: ' + JSON.stringify(profileData));
  localStorage.setItem('windUser', stringifySafe(profileData));
  if (remote) {
    postFetch(`${config.backEndUrl}/wind_users/${profileData.id}.json`, stringifySafe(profileData), {'Accept': 'application/json', 'Content-Type': 'application/json'})
      .then((resp) => {
        console.debug('resp: ' + JSON.stringify(resp));
      });
  }
}

function defaultUserProfile() {
  return {
    email: 'test@windmorbihan.com',
    spots: [defaultUserSpot('1'), defaultUserSpot('2'), defaultUserSpot('3')],
    demoSpot: defaultUserSpot('DEMO')
  }
}

function stringifySafe(obj) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  });
}
